import cls from "classnames";
import { Tab } from "@headlessui/react";
import { useState } from "react";

import ChannelCard from "./ChannelCard";
import CourseCard from "./CourseCard";
import EmptyTab from "./EmptyTab";

import * as Track from "@qoohoo/common/utils/analytics/track";
import { button, pageview } from "@qoohoo/common/constants/analytics";

// number of channels to show in a tab before showing a "See More" button
const CHANNEL_LIST_LIMIT = 8;

export default function ChannelsTab({
  posts,
  title,
  isProfileOwner,
  isCreator,
}) {
  const [pointer, setPointer] = useState(CHANNEL_LIST_LIMIT);

  return (
    <Tab.Panel
      className={cls(
        "bg-transparent pt-8 lg:pt-10 px-5 lg:px-0 text-left mx-auto",
        "focus:outline-none"
      )}
    >
      {posts.length > 0 ? (
        <ul className="channel-list">
          {posts.slice(0, pointer).map((post, index) => {
            const isChannelTypeCourse = post.type === "course";

            return isChannelTypeCourse ? (
              <CourseCard
                key={index}
                post={post}
                isProfileOwner={isProfileOwner}
                isCreator={isCreator}
              />
            ) : (
              <ChannelCard
                key={index}
                post={post}
                isProfileOwner={isProfileOwner}
                isCreator={isCreator}
              />
            );
          })}
        </ul>
      ) : (
        <EmptyTab tabName={title} />
      )}
      {posts.length > pointer && (
        <div className="text-center max-h-[21px] mt-5 lg:mt-8">
          <button
            onClick={() => {
              Track.buttonClick(button.tab_show_more, {
                actionType: "click",
                label: title,
                current_screen: pageview.profile,
              });
              setPointer(pointer + CHANNEL_LIST_LIMIT);
            }}
            className="font-inter text-[#58A6EE] text-xs lg:text-sm leading-[18px] hover:opacity-90"
          >
            Show more
          </button>
        </div>
      )}
    </Tab.Panel>
  );
}
